/**
 * HomeSLAlmadarHomePageView
 *
 * Page component for HomeSLAlmadarHomePageView
 * Path: /sl
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { HomeSLAlmadarHomePageView as __HomeSLAlmadarHomePageView } from '@/components/traits/HomeSLAlmadarHomePageView';
import { HomeSLHomeAnalyticsView as __HomeSLHomeAnalyticsView } from '@/components/traits/HomeSLHomeAnalyticsView';
import { HomeSLDemoTicketDeskView as __HomeSLDemoTicketDeskView } from '@/components/traits/HomeSLDemoTicketDeskView';
import { HomeSLDemoStockPageDeskView as __HomeSLDemoStockPageDeskView } from '@/components/traits/HomeSLDemoStockPageDeskView';
import { HomeSLDemoPeopleDeskView as __HomeSLDemoPeopleDeskView } from '@/components/traits/HomeSLDemoPeopleDeskView';
import { HomeSLDemoInvoicePageDeskView as __HomeSLDemoInvoicePageDeskView } from '@/components/traits/HomeSLDemoInvoicePageDeskView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';
import { ToastSlot } from '@almadar/ui/components';

interface HomeSLAlmadarHomePageViewProps {
  // Add any page-level props here
}

export function HomeSLAlmadarHomePageView(_props: HomeSLAlmadarHomePageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-home:meta.title"],"description":["i18n/t","std-almadar-home:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/"},{"locale":"ar","path":"/ar"},{"locale":"sl","path":"/sl"}],"defaultLocale":"en", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__HomeSLAlmadarHomePageView config={{ initPayload: __navState }} />
          <__HomeSLHomeAnalyticsView config={{ initPayload: __navState }} />
          <__HomeSLDemoTicketDeskView config={{ initPayload: __navState }} />
          <__HomeSLDemoStockPageDeskView config={{ initPayload: __navState }} />
          <__HomeSLDemoPeopleDeskView config={{ initPayload: __navState }} />
          <__HomeSLDemoInvoicePageDeskView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default HomeSLAlmadarHomePageView;
